(function () {
  function currentCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function prettyHandle(value) {
    return String(value || '').replace(/-/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function injectStandardStyles() {
    if (document.getElementById('SoyActiveStandardCollectionStyles')) return;
    var style = document.createElement('style');
    style.id = 'SoyActiveStandardCollectionStyles';
    style.textContent = '' +
      '.soy-shop-layout{scroll-margin-top:120px}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-breadcrumb{display:none}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-head{position:relative;isolation:isolate;width:100vw;min-height:clamp(480px,62vh,720px);margin-left:calc(50% - 50vw);margin-bottom:clamp(36px,5vw,64px);padding:clamp(42px,6vw,88px);box-sizing:border-box;display:flex;flex-direction:column;justify-content:flex-end;align-items:flex-start;overflow:hidden;background:linear-gradient(135deg,#0b1d33 0%,#132f50 100%);color:#fff}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-head:before{content:"";position:absolute;inset:0;z-index:-1;background:linear-gradient(90deg,rgba(8,12,16,.82) 0%,rgba(8,12,16,.58) 36%,rgba(8,12,16,.18) 70%,rgba(8,12,16,.08) 100%);pointer-events:none}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle="core"] .soy-collection-head{background-image:url("https://cdn.shopify.com/s/files/1/1035/1758/5755/files/home-hero-core-city-life-2026-09-12.png?v=1789253836");background-size:cover;background-position:center}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle="shop-all"] .soy-collection-head{background-image:url("https://cdn.shopify.com/s/files/1/1035/1758/5755/files/home-hero-brand-overview-2026-09-12.png?v=1789253825");background-size:cover;background-position:center}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-intro{position:relative;z-index:1;max-width:850px}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-intro .soy-kicker{color:rgba(255,255,255,.9)}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-intro h1{margin:0 0 18px;max-width:900px;font-size:clamp(58px,8vw,112px);line-height:.84;letter-spacing:-.06em;color:#fff}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-lede{max-width:720px;margin:0;color:rgba(255,255,255,.9);font-size:clamp(15px,1.35vw,19px);line-height:1.55}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips{position:relative;z-index:1;justify-content:flex-start;margin-top:28px}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips a{border-color:rgba(255,255,255,.5);background:rgba(8,12,16,.18);color:#fff;backdrop-filter:blur(4px)}' +
      '.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips a:hover{background:#fff;border-color:#fff;color:#0b1d33}' +
      '.soy-standard-collection-link{display:inline-flex;width:max-content;margin-top:22px;padding-bottom:3px;border-bottom:1px solid rgba(255,255,255,.82);color:#fff;text-decoration:none;font-size:11px;font-weight:800;letter-spacing:.08em;text-transform:uppercase}' +
      '.soy-collection-shell .soy-active-hero .soy-active-hero-link{display:inline-flex!important}' +
      '@media(max-width:749px){.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-head{min-height:620px;margin-bottom:34px;padding:32px 20px 56px}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-head:before{background:linear-gradient(0deg,rgba(8,12,16,.86) 0%,rgba(8,12,16,.5) 54%,rgba(8,12,16,.12) 100%)}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-intro h1{font-size:clamp(58px,17vw,78px);margin-bottom:16px}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-collection-lede{font-size:15px}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips{width:100%;flex-wrap:nowrap;overflow-x:auto;padding-bottom:4px;scrollbar-width:none}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips::-webkit-scrollbar{display:none}.soy-collection-shell.soy-active-standard[data-collection-handle] .soy-category-chips a{white-space:nowrap}}';
    document.head.appendChild(style);
  }

  function installCollectionStandard() {
    injectStandardStyles();
    var handle = currentCollectionHandle();
    document.querySelectorAll('.soy-collection-shell').forEach(function (shell) {
      shell.dataset.collectionHandle = handle;
      shell.classList.add('soy-active-standard');

      var layout = shell.querySelector('.soy-shop-layout');
      if (layout && !layout.id) layout.id = 'soy-collection-results';

      var head = shell.querySelector('.soy-collection-head');
      var intro = head && head.querySelector('.soy-collection-intro');
      if (intro && !intro.querySelector('[data-soy-standard-cta]')) {
        var link = document.createElement('a');
        link.href = '#soy-collection-results';
        link.className = 'soy-standard-collection-link';
        link.dataset.soyStandardCta = '';
        link.textContent = handle === 'shop-all' ? 'Explore all pieces' : 'Explore ' + prettyHandle(handle || 'the collection');
        intro.appendChild(link);
      }
    });
  }

  function bootCollection() {
    installCollectionStandard();

    document.querySelectorAll('[data-soy-sort]').forEach(function (select) {
      if (select.dataset.ready === 'true') return;
      select.dataset.ready = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('[data-soy-filter-toggle]').forEach(function (button) {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        var marker = button.querySelector('span');
        if (marker) marker.textContent = open ? '-' : '+';
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCollection);
  else bootCollection();
  document.addEventListener('shopify:section:load', bootCollection);
})();
